var MotionGlobalConfig = {};
export { MotionGlobalConfig };